/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TestStepConfigurationDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    type: TestStepConfigurationDto.type;
};
export namespace TestStepConfigurationDto {
    export enum type {
        STRING = 'STRING',
        NUMERIC = 'NUMERIC',
        SELECTION = 'SELECTION',
    }
}

